import { useQuery } from 'react-query';
import axios from 'axios';
import { AgentAPI } from '../../constants/API';
import { commonHeaders } from '../../constants/HeadersAPI';

export type TicketType = {
  comments: string[] | [];
  createdAt: string;
  itemId: number;
  name: string;
  requestedAt: string;
  status: string;
  topicName: string;
  extraData?: string | null;
};

export const useGetUsedTicket = (
  isWorkPlaceSelected: boolean,
  setRefreshTicket: (ticket: TicketType | null) => void
) => {
  const {
    data: usedTicket,
    isFetching: isLoadingUsedTicket,
    isError: isErrorTicket,
    isSuccess: isSuccessUsedTicket
  } = useQuery(
    ['usedTicket'],
    async () => {
      const { data } = await axios.get<TicketType | null>(
        `${AgentAPI.changeTicketStatus}/refresh`,
        commonHeaders()
      );
      return data ?? null;
    },
    {
      onSuccess: (ticket) => {
        setRefreshTicket(ticket);
      },
      enabled: isWorkPlaceSelected,
      refetchInterval: isWorkPlaceSelected ? 3000 : false,
      refetchIntervalInBackground: true,
    }
  );
  return {
    usedTicket,
    isLoadingUsedTicket,
    isErrorTicket,
    isSuccessUsedTicket
  };
};
